import { Injectable } from '@angular/core';
import { User, UserManager, UserManagerSettings } from 'oidc-client-ts';
import { environment } from '../../environments/environment';

import { GraphService } from './graph.service';

@Injectable({
  providedIn: 'root'
})
export class SsoSecurityService {
 
  public manager = null;
  //new UserManager(getClientSettings());
  public user: User = null;
  
  constructor() {
    this.instantiate();
     this.manager.getUser().then(user => {
      this.user = user;
    });
  }
  
    isLoggedIn(): boolean {
 // let user=this.graphservice.getProfile();   
  
  return this.user != null && !this.user.expired;
  }
  
  getClaims(): any {
    return this.user.profile;
  }
  
  getAuthorizationIdTokenHeaderValue(): string {
    return this.user?`${this.user.token_type} ${this.user.id_token}`:null;
  }
  
  getAuthorizationHeaderValue(): string {
    return this.user?`${this.user.token_type} ${this.user.access_token}`:null;
  }
  
  public async accessToken(): Promise<string> {
          var user = await this.manager.getUser();
          if (user == null) {
             this.startAuthentication();
          }
          return user.access_token;
  }
  
  startAuthentication(): Promise<void> {
    return this.manager.signinRedirect();
  }

  checkLogin():Promise<void>{
    return this.manager.signinRedirectCallback().then(user => {
      this.user = user;
    }).catch((err) => {
      this.user = null;
    
    })
  }
  
  completeAuthentication(): Promise<void> {
    return this.manager.signinRedirectCallback().then(user => {
      this.user = user;
    }).catch((err) => {
      this.user = null;
    
    })
  }
  
  public async clearsession(): Promise<any>{
    
    await this.manager.clearStaleState();
  }
  public async logoutRedirect(): Promise<any> {
          this.user=null,
          await this.manager.clearStaleState();
          await this.manager.signoutRedirect();
         
      }
  
      public instantiate() {
              const settings = environment.oidcSettings;
              this.manager = new UserManager(settings);
             
            
          }
   
   
 

  public subscribeevents() :void {
    this.manager.events.addSilentRenewError(() => {
      console.log("error SilentRenew");
    });

    this.manager.events.addAccessTokenExpiring(() => {
      console.log("access token expiring");
    });

    this.manager.events.addAccessTokenExpired(() => {
      console.log("access token expired");
    });
  }
  
  public refreshCallBack()
  {
    console.log("start refresh callback");
    this.manager.signinSilentCallback()
      .then(data => {console.log("suucess callback")})
      .catch(err => {
          console.log("err callback");
      });
      console.log("end refresh callback");
  }

   
        }
    // export function getClientSettings(): UserManagerSettings {
    //   return {
    //     client_id : '9b4d001d-8577-487d-b5bd-4a420fe5337a',
    //     authority: 'https://login.microsoftonline.com/0515a231-f891-433a-b4f7-9f1a7b76ae45/v2.0/',
    //     redirect_uri: 'http://localhost:4200/auth-callback',
    //     post_logout_redirect_uri: 'http://localhost:4200/',
    //     response_type: "code",
    //     scope: "openid profile user.read",
    //     filterProtocolClaims: true,
    //     loadUserInfo: true
    //   };
  //}